// src/components/icons/index.js
import React from "react";
import { IoPrintOutline } from "react-icons/io5";
import { BiLogoHtml5, BiLogoCss3 } from "react-icons/bi";
import { DiPython, DiLinux, DiWindows, DiJsBadge, DiAngularSimple, DiReact } from "react-icons/di";
import { FaPhp } from "react-icons/fa6";
import { MdHtml, MdCss } from "react-icons/md";
import { BsRouter, BsWifi } from "react-icons/bs";
import { SiGimp, SiInkscape } from "react-icons/si";
import { GrMysql } from "react-icons/gr";

import {
  ExternalLinkAltIcon,
  BookOpenIcon,
  BookIcon,
  UniversalAccessIcon,
  ClipboardCheckIcon,
  UserShieldIcon,
  FileContractIcon,
  IdCardIcon,
  GraduationCapIcon,
  LaptopCodeIcon,
  CodeIcon,
  LanguageIcon,
  FirstAidIcon,
  ShieldAltIcon,
  FileMedicalAltIcon,
  HomeIcon,
  SchoolIcon,
  NewspaperIcon,
  EnvelopeIcon,
  ClockIcon,
  EuroSignIcon,
  RocketIcon,
  FolderOpenIcon,
  ApplicationsIcon
} from "@patternfly/react-icons";

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTiktok,
} from "react-icons/fa6";

export const Icons = {
  // ==========================
  // Technology
  // ==========================
  Linux: <DiLinux size={18} style={{ marginRight: 5, marginBottom: -5 }} />,
  Windows: <DiWindows size={20} style={{ marginRight: 5, marginBottom: -5 }} />,
  Php: <FaPhp size={24} style={{ marginRight: 5, marginBottom: -8 }} />,
  Js: <DiJsBadge size={21} style={{ marginRight: 5, marginBottom: -6 }} />,
  Printer: <IoPrintOutline size={19} style={{ marginRight: 5, marginBottom: -6 }} />,
  Router: <BsRouter size={20} style={{ marginRight: 5, marginBottom: -8 }} />,
  Wifi: <BsWifi size={20} style={{ marginRight: 5, marginBottom: -5 }} />,
  Html: <BiLogoHtml5 size={22} style={{ marginRight: 5, marginBottom: -8 }} />,
  Css: <BiLogoCss3 size={22} style={{ marginRight: 5, marginBottom: -8 }} />,
  Gimp: <SiGimp size={22} style={{ marginRight: 5, marginBottom: -8 }} />,
  Sql: <GrMysql size={22} style={{ marginRight: 5, marginBottom: -8 }} />,
  Inkscape: <SiInkscape size={20} style={{ marginRight: 5, marginBottom: -8 }} />,
  // ==========================
  // SkillMeasure
  // ==========================
  linux: <DiLinux style={{ fontSize: '1.5em' }} />,
  windows: <DiWindows style={{ fontSize: '1.5em' }} />,
  ls: <DiLinux style={{ fontSize: '1.5em' }} />,
  ws: <DiWindows style={{ fontSize: '1.5em' }} />,
  js: <DiJsBadge style={{ fontSize: '1.5em' }} />,
  php: <FaPhp style={{ fontSize: '1.5em' }} />,
  angular: <DiAngularSimple style={{ fontSize: '1.5em' }} />,
  react: <DiReact style={{ fontSize: '1.5em' }} />,
  html: <MdHtml style={{ fontSize: '1.5em' }} />,
  css: <MdCss style={{ fontSize: '1.5em' }} />,
  mysql: <GrMysql style={{ fontSize: '1.5em' }} />,
  router: <BsRouter style={{ fontSize: '1.5em' }} />,
  wifi: <BsWifi style={{ fontSize: '1.5em' }} />,
  gimp: <SiGimp style={{ fontSize: '1.5em' }} />,
  inkscape: <SiInkscape style={{ fontSize: '1.5em' }} />,
  prt: <DiPython style={{ fontSize: '1.7em', position: 'relative', top: '4px' }} />,
  python: <DiPython style={{ fontSize: '1.7em' }} />,

  // ==========================
  // MegaMenu
  // ==========================
  BookOpenIcon: <BookOpenIcon />,
  BookIcon: <BookIcon />,
  ExternalLinkAltIcon: <ExternalLinkAltIcon />,
  // ==========================
  // School navigation
  // ==========================
  HomeIcon: <HomeIcon />,
  SchoolIcon: <SchoolIcon />,
  UniversalAccessIcon: <UniversalAccessIcon />,
  ClipboardCheckIcon: <ClipboardCheckIcon />,
  UserShieldIcon: <UserShieldIcon />,
  IdCardIcon: <IdCardIcon />,
  FileContractIcon: <FileContractIcon />,
  GraduationCapIcon: <GraduationCapIcon />,
  LaptopCodeIcon: <LaptopCodeIcon />,
  CodeIcon: <CodeIcon />,
  LanguageIcon: <LanguageIcon />,
  FirstAidIcon: <FirstAidIcon />,
  FileMedicalAltIcon: <FileMedicalAltIcon />,
  ShieldAltIcon: <ShieldAltIcon />,
  NewsIcon: <NewspaperIcon />,
  ContactIcon: <EnvelopeIcon />,
  FolderOpenIcon: <FolderOpenIcon />,

  // ==========================
  // School header actions
  // ==========================
  EDziennikIcon: <BookOpenIcon />,
  MailIcon: <EnvelopeIcon />,
  // ==========================
  // Education
  // ==========================
  ApplicationsIcon: <ApplicationsIcon />,

  // ==========================
  // Socials
  // ==========================
  Facebook: <FaFacebook />,
  Instagram: <FaInstagram />,
  Youtube: <FaYoutube />,
  Tiktok: <FaTiktok />,

  // ==========================
  // Erasmus
  // ==========================
  ErasmusDuration: <ClockIcon />,
  ErasmusFunding: <EuroSignIcon />,
  ErasmusBenefits: <RocketIcon />,
};

export const getIcon = (name) => Icons[name] ?? null;